// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eLai","colBig":"styles_colBig__3i5-4","colSmall":"styles_colSmall__1byvD"};